"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createComponent_1 = require("./createComponent");
exports.createReactComponent = createComponent_1.createReactComponent;
var createOverlayComponent_1 = require("./createOverlayComponent");
exports.createOverlayComponent = createOverlayComponent_1.createOverlayComponent;
//# sourceMappingURL=index.js.map